import * as searchbarState from 'nh-vue-layout/store/searchbar/state.js'
import * as searchbarMutations from 'nh-vue-layout/store/searchbar/mutations.js'
import * as searchbarGetters from 'nh-vue-layout/store/searchbar/getters.js'
import * as searchbarActions from 'nh-vue-layout/store/searchbar/actions.js'

const stateSb = searchbarState.default()
const mutationsSb = searchbarMutations.default
const gettersSb = searchbarGetters.default
const actionsSb = searchbarActions.default

export const state = () => ({
  ...stateSb
})

export const getters = gettersSb

export const mutations = mutationsSb

export const actions = actionsSb
